<template>
    <h3 class="text-xl font-semibold text-gray-900 dark:text-gray-200">
        {{ title }}
    </h3>
    <p class="mt-1 max-w-2xl text-sm text-gray-500">
        {{ caption }}
    </p>
    <div class="bg-white dark:bg-dark-700 dark:border-dark-600 text-gray-700 dark:text-gray-200 p-4 rounded-lg mt-2">
        <div class="space-y-2">
            <div v-for="(item, index) in items" :key="index"
                class="flex justify-between items-center space-y-1 md:flex-row md:space-y-0 md:justify-between md:items-center pb-3">
                <div class="text-lg font-medium text-gray-500 dark:text-gray-400">
                    {{ item.field }}
                </div>
                <div v-if="item.type === 'text'" class="text-lg text-gray-900 dark:text-gray-100">
                    {{ item.value }}
                </div>
                <div v-else-if="item.type === 'rupiah'" class="text-xl font-semibold text-gray-900 dark:text-gray-100">
                    {{ formatRupiah(item.value) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { formatRupiah } from '@/helpers/formatRupiah';

export default {
    name: 'DetailComponent',
    components: {
    },
    props: {
        title: {
            type: String,
            default: 'Ringkasan Pesanan'
        },
        caption: {
            type: String,
            default: null
        },
        items: {
            type: Array,
            default: null
        },
    },
    methods: {
        formatRupiah
    }
}
</script>